import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_packing_gendoc_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_running_no: fromDatatype.GuidDataFieldInterface;
    gendoc_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    gendoc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}


export class bl_wms_packing_gendoc_link_RowClass
    implements bl_wms_packing_gendoc_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_list_running_no: fromDatatype.GuidDataFieldInterface;
    gendoc_server_doc_1: fromDatatype.VarcharDatatypeInterface;
    gendoc_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}